/*
 * skip-sub.js  ·  v2.1 · PDP-locked (variant B · ink/black)
 * ─────────────────────────────────────────────────────────────────────────
 * Powers the "fear of commitment? skip the sub" toggle on the PDP bundle row.
 * Targets .plan-bundle (used by sections/pdp-mainProductRefactor.liquid).
 *
 * Klaviyo events fired:
 *   • 'Toggled Skip-Sub'           (toggle flipped)
 *   • 'Cart Added With Skip-Sub'   (add-to-cart with toggle ON)
 *
 * Discount path: applies SKIPTHESUB at cart-add time when toggle is ON.
 *
 * Include in theme.liquid:
 *   {{ 'skip-sub.js' | asset_url | script_tag }}
 * ─────────────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  var CONFIG = {
    discountCode: 'SKIPTHESUB',
    sessionKey:   'ooedn-skip-sub-discount'
  };

  function track(event, props) {
    try {
      if (typeof window._learnq !== 'undefined') {
        window._learnq.push(['track', event, props || {}]);
      }
      if (typeof console !== 'undefined') {
        console.info('[ooedn:skip-sub]', event, props || {});
      }
    } catch (e) { /* no-op */ }
  }

  function initToggle() {
    var toggleInput  = document.querySelector('[data-ooedn-skip-sub-input]');
    var skipSubBlock = document.querySelector('[data-ooedn-skip-sub]');
    if (!toggleInput || !skipSubBlock) return;

    var bundleCard = skipSubBlock.closest('.plan-bundle') ||
                     skipSubBlock.closest('.pcard__plan--hero');
    if (!bundleCard) {
      console.warn('[ooedn:skip-sub] no parent .plan-bundle or .pcard__plan--hero found');
      return;
    }

    toggleInput.addEventListener('change', function () {
      var onCharge = toggleInput.checked;
      bundleCard.classList.toggle('is-onecharge', onCharge);

      // Update PDP add-to-cart CTA copy
      var ctaText = document.querySelector('[data-pdp-cta-text]');
      if (ctaText) {
        if (onCharge) {
          if (!ctaText.dataset.subText) ctaText.dataset.subText = ctaText.textContent;
          ctaText.textContent = 'one charge · no auto-renew';
        } else if (ctaText.dataset.subText) {
          ctaText.textContent = ctaText.dataset.subText;
        }
      }

      // LP pcard CTA wiring (if rendered on an LP rather than PDP)
      var pcardCtaMain  = document.querySelector('[data-pcard-cta-main]');
      var pcardCtaStrap = document.querySelector('[data-pcard-cta-strap]');
      if (pcardCtaMain) {
        if (onCharge) {
          if (!pcardCtaMain.dataset.subText) pcardCtaMain.dataset.subText = pcardCtaMain.textContent;
          pcardCtaMain.textContent = 'add to cart · one charge';
        } else if (pcardCtaMain.dataset.subText) {
          pcardCtaMain.textContent = pcardCtaMain.dataset.subText;
        }
      }
      if (pcardCtaStrap) {
        if (onCharge) {
          if (!pcardCtaStrap.dataset.subText) pcardCtaStrap.dataset.subText = pcardCtaStrap.textContent;
          pcardCtaStrap.textContent = 'no auto-renew · 90 days';
        } else if (pcardCtaStrap.dataset.subText) {
          pcardCtaStrap.textContent = pcardCtaStrap.dataset.subText;
        }
      }

      // Flag the bundle radio so add-to-cart intercept can detect intent
      var bundleRadio = bundleCard.querySelector('input[type="radio"][name="plan"]');
      if (bundleRadio) {
        if (onCharge) {
          bundleRadio.dataset.onecharge = 'true';
        } else {
          delete bundleRadio.dataset.onecharge;
        }
      }

      // Custom event for any other wiring to react
      var evt = new CustomEvent('ooedn:skipSubToggle', {
        detail: { onCharge: onCharge },
        bubbles: true
      });
      bundleCard.dispatchEvent(evt);

      track('Toggled Skip-Sub', { state: onCharge ? 'onecharge' : 'subscription' });
    });
  }

  function initAddToCartIntercept() {
    var pdpCta = document.querySelector('[data-pdp-cta]');
    if (!pdpCta) return;

    pdpCta.addEventListener('click', function () {
      var bundleRadio = document.querySelector('.plan-bundle input[type="radio"][name="plan"]');
      if (!bundleRadio || !bundleRadio.dataset.onecharge) return;
      try {
        sessionStorage.setItem(CONFIG.sessionKey, CONFIG.discountCode);
      } catch (e) {}
      track('Cart Added With Skip-Sub', { code: CONFIG.discountCode });
    });
  }

  function init() {
    initToggle();
    initAddToCartIntercept();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
